import { Directive, OnDestroy, Output, EventEmitter, HostListener, forwardRef, NgZone } from "@angular/core";
import { ActionSheetController, AlertController, Platform } from "@ionic/angular";
//import { Camera, CameraOptions } from '@ionic-native/camera';
import { ActionSheetButton } from "@ionic/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";
import { CameraResultType } from "@capacitor/camera";
import { Plugins } from "@capacitor/core/dist";
import { combineLatest, BehaviorSubject } from "rxjs";
import { FirebaseFileUploadService } from "@core/firebase-fileupload.service";
import { FB_PROFILE_PIC_BASE_URL, FB_SYNDICATE_COVER_PIC_BASE_URL } from "src/app/app.constants";
import { UtilityService } from "@core/utility.service";
import { PrivateSyndicateRepositoryService } from "src/app/pages/private-syndicate/private-syndicate.repository.service";
import { TranslateService } from "@ngx-translate/core";
import { AuthService } from "@core/auth.service";

const { Camera } = Plugins;

@Directive({
    selector: "[file-upload]",
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FileUploadDirective),
            multi: true,
        },
    ],
    standalone: true,
})
export class FileUploadDirective implements ControlValueAccessor {
  @Output() imageAdded: EventEmitter<string> = new EventEmitter();
  private cameraDefaultOptions = {
    resultType: CameraResultType.DataUrl,
    allowEditing: true,
    quality: 100,
  };
  private allowedFile = ["image/png", "image/jpeg"];
  private propagateChange = (_: any) => { };
  private onTouched = () => { };
  @HostListener("click") onClick = () => {
    this.onTouched();
    this.selectImage();
  };
  translatedToastMsg: any;
  selectedLanguage: string = "en";

  constructor(
    private actionSheetController: ActionSheetController,
    private fileUploadService: FirebaseFileUploadService,
    private ngZone: NgZone,
    public translate: TranslateService,
    private authService: AuthService,
  ) {
    this.authService?.selectedlanguage$?.subscribe(
      (l) => {
        this.selectedLanguage = l;
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );

    this.authService?.getConstantsMsg$?.subscribe((msg: any) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    })


  }

  async selectImage() {
    const actionSheet = await this.actionSheetController.create({
      header: "Add cover profile",
      mode: "ios",
      buttons: [
        {
          text: "Gallery",
          handler: () => {
            this.ngZone.run(() => {
              this.uploadFileDesktop();
            });
          },
        },
        {
          text: "Camera",
          handler: () => {
            this.ngZone.run(() => {
              Camera.requestPermissions().then(() => {
                  this.requestImage();
                })
                .catch((error) => {
                  return error;
                });
            });
          },
        },
        {
          text: "Remove Photo",
          handler: () => {
            this.ngZone.run(() => {
              this.propagateChange(null);
            });
          },
        },
        {
          text: "Cancel",
          role: "cancel",
          handler: () => {
          },
        },
      ],
    });
    await actionSheet.present();
  }

  private uploadFileDesktop() {
    const fileInput = document.createElement("input");
    fileInput.setAttribute("type", "file");
    fileInput.setAttribute("accept", this.allowedFile.join());
    fileInput.click();

    const changeListener = () => {
      if (fileInput.files?.length) {
        const file = fileInput.files.item(0);
        if (this.allowedFile.includes(file.type)) {
          setTimeout(() => {
            this.fileUploadService.uploadedPercent$.next(10);
          }, 1000);
          this.fileUploadService
            .updateProfileImage(fileInput.files, "privateSyndicate/privateUser/")
            .then((fileName: string) => {
              this.imageAdded.emit(
                FB_SYNDICATE_COVER_PIC_BASE_URL +
                  UtilityService.insertString(fileName?.split(".")[0].length, "_400x400", fileName) +
                  "?alt=media"
              );

              this.propagateChange(
                FB_SYNDICATE_COVER_PIC_BASE_URL +
                  UtilityService.insertString(fileName?.split(".")[0].length, "_400x400", fileName) +
                  "?alt=media"
              );
            })
            .catch((err) => {
              this.propagateChange(null);
              /* const msg = this.translatedToastMsg?.["1094"]?.[this.selectedLanguage];
              this.authService.showToast(msg ? msg : "something went wrong! please select image again", "error", ""); */
              this.authService.getConstantsMsg("1094").then((translatedMsg) => {
                  const defaultMsg = {
                    message: {
                      line_1: "something went wrong! please select image again",
                      line_2: "",
                    },
                    style: {
                      icon: "tick circle error.svg",
                      type: "Error",
                    },
                  }
                  this.authService.showToastMessage(translatedMsg, defaultMsg);
                })
                .catch((error) => {
                  return error;
                });
              return err;
            });
        }
      } else {
        this.propagateChange(null);
      }
      fileInput.removeEventListener("change", changeListener);
    };

    fileInput.addEventListener("change", changeListener);
  }

  private requestImage() {
    Camera.getPhoto({
      resultType: CameraResultType.DataUrl,
      quality: 100,
    })
      .then((imageData) => {
        this.uploadProfilePicBase64(imageData);
      })
      .catch((err) => {
        return err;
      });
  }

  private uploadProfilePicBase64(blob: any) {
    setTimeout(() => {
      this.fileUploadService.uploadedPercent$.next(10);
    }, 1000);
    this.fileUploadService
      .updateProfileImageUsingBase64(blob, "privateSyndicate/privateUser/")
      .then((imageName: string) => {
        this.imageAdded.emit(
          FB_SYNDICATE_COVER_PIC_BASE_URL +
            UtilityService.insertString(imageName?.split(".")[0].length, "_400x400", imageName) +
            "?alt=media"
        );
        this.propagateChange(
          FB_SYNDICATE_COVER_PIC_BASE_URL +
            UtilityService.insertString(imageName?.split(".")[0].length, "_400x400", imageName) +
            "?alt=media"
        );
      })
      .catch((error) => {
        return error;
      });
  }

  clear() {
    this.imageAdded.emit(null);
  }

  public writeValue() { }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }
}
